import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CONTACT_SUPPORT_TEL,
  CONTACT_SUPPORT_TEL_2,
  CONTACT_SUPPORT_TEL_3,
  CONTACT_SUPPORT_TEL_4,
} from 'shared/constants';
import { Link } from 'react-router-dom';
import './ContactSupport.scss';

const ContactSupport = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-support-container">
      <div className="contact-support">
        <h6 style={{ marginBottom: '2rem' }}>{t('profile.contactSupport.heading1')}</h6>
        <p className="text-pacific-blue">
          <a href={`tel:${CONTACT_SUPPORT_TEL}`}>
            <i className="material-icons">phone</i>
            <span>{t('profile.contactSupport.callUsLabel')} </span>
            <span className="support-number">{CONTACT_SUPPORT_TEL}</span>
          </a>
        </p>

        <p className="text-pacific-blue" style={{ marginBottom: '1.5rem' }}>
          <Link to="/email-us">
            <i className="material-icons">email</i>
            <span>{t('profile.contactSupport.emailUsLabel')}</span>
          </Link>
        </p>

        <div className="call-us">
          {t('profile.contactSupport.callUsLabel')} <span>{CONTACT_SUPPORT_TEL_2}</span>
        </div>
        <div className="manually-dialed">{t('profile.contactSupport.manuallyDialedMessage')}</div>
      </div>

      <div className="contact-support contact-support-state-district">
        <h6 style={{ marginBottom: 0 }}>{t('profile.contactSupport.heading2')}</h6>
        <p className="helper-text">{t('profile.contactSupport.helperText')}</p>

        <p className="text-pacific-blue">
          <a href={`tel:${CONTACT_SUPPORT_TEL_3}`}>
            <i className="material-icons">phone</i>
            <span>{t('profile.contactSupport.callUsLabel')} </span>
            <span className="support-number">{CONTACT_SUPPORT_TEL_3}</span>
          </a>
        </p>

        <div className="email-links">
          <div>
            <span className="text-pacific-blue">
              <i className="material-icons">email</i>
              <span>{t('profile.contactSupport.emailUsLabel')} - State:</span>
            </span>
            <span style={{ fontWeight: 'bold' }}> {t('profile.contactSupport.email1')}</span>
          </div>
          <div>
            <span className="text-pacific-blue">
              <i className="material-icons">email</i>
              <span>{t('profile.contactSupport.emailUsLabel')} - District:</span>
            </span>
            <span style={{ fontWeight: 'bold' }}> {t('profile.contactSupport.email2')}</span>
          </div>
        </div>

        <div className="call-us">
          {t('profile.contactSupport.callUsLabel')} <span>{CONTACT_SUPPORT_TEL_4}</span>
        </div>
        <div className="manually-dialed">{t('profile.contactSupport.manuallyDialedMessage')}</div>
      </div>
    </div>
  );
};

export default ContactSupport;
